<template>
    <div class="products">
        <div class="data-container">
            <b-table
                show-empty
                :items="products"
                :empty-text="(loading) ? 'Loading data' : 'No product records found'"
                :fields="fields"
                responsive>
                <!-- <template slot="name" slot-scope="data">
                    {{ data.item.name }} 
                </template> -->
                <template slot="price" slot-scope="data">
                    Php {{ data.item.price | regularPrice }}
                </template>
                <template slot="variation_code" slot-scope="data">
                    N/A
                </template>
                <!-- <template slot="sale_price" slot-scope="data">
                    <template v-if="data.item.on_sale === 0">
                        N/A
                    </template>
                    <template v-else-if="new Date(data.item.on_sale_to) < Date.now()">
                        N/A
                    </template>
                    <template v-else>
                        {{ data.item.regular_price | salePrice(data.item.discount_value, data.item.discount_type) }}
                    </template>
                </template> -->
                <template slot="type" slot-scope="data">
                    <span class="text-capitalize">
                        {{ data.item.type }}
                    </span>
                </template>
                <template slot="category" slot-scope="data">
                    <template v-if="data.item.category !== null">
                        {{ data.item.category.name }}
                    </template>
                    <!-- {{ getCategoryName(data.item.product_details.category_id) }} -->
                </template>
                <!-- <template slot="visibility" slot-scope="data">
                    <div id="product-visibility">
                        <switches 
                            v-model="data.item.visibility"
                            :emit-on-mount="false"
                            theme="custom"
                            color="primary"
                            text-enabled="On"
                            text-disabled="Off"
                            type-bold="true"
                            @input="updateVisibility({
                                uuid: data.item.uuid,
                                product_uuid: data.item.product_details.uuid,
                                product_type: data.item.product_details.type,
                                visibility: data.item.visibility
                            })">
                        </switches>
                    </div>
                </template> -->
                <!-- <template slot="sale_schedule" slot-scope="data">
                    <template v-if="data.item.on_sale === 0">
                        N/A
                    </template>
                    <template v-else>
                        {{data.item.on_sale_from | formatDate}} - {{data.item.on_sale_to | formatDate}}
                    </template>
                </template> -->
                <template slot="action" slot-scope="data">
                    <b-button
                        variant="ghost btn-table-edit-activation-key mr-2"
                        @click="editProduct({
                                        uuid: data.item.uuid
                                    })"
                    >
                    </b-button>
                    <b-button
                        variant="ghost btn-table-view-activation-key mr-2"
                        :to="{ name: 'dstoreProductsActivationKeys', params: { id: data.item.uuid }, query: { name: data.item.name } }"
                    >
                    </b-button>
                    <b-button
                        variant="ghost btn-table-delete-activation-key mr-2"
                        @click="deleteProduct({
                                    uuid: data.item.uuid,
                                    name: data.item.name,
                                    productActivationKeysCount: data.item.product_activation_keys_count
                                })"
                    >
                    </b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";
import moment from "moment";
import notification from "../../../services/notification";

export default {
    name: "InventoryTable",
    data() {
        return {
            fields: [
                {
                    key: "name",
                    sortable: true
                },
                {
                    key: "category",
                    label: "Category",
                    sortable: true
                },
                {
                    key: "type",
                    label: "Product Type",
                    sortable: true
                },
                {
                    key: "variation_code",
                    label: "Variation",
                    sortable: true
                },
                {
                    key: "sku",
                    label: "SKU"
                },
                {
                    key: "price",
                    label: "Price",
                    sortable: true
                },
                // {
                //     key: "stock",
                //     label: "Stock Qty."
                // },
                // {
                //     key: "sale_price",
                //     sortable: true
                // },
                // {
                //     key: "sale_schedule"
                // },
                // "visibility",
                "action"
            ]
        };
    },
    components: {
        Switches
    },
    created: function() {
        this.getProducts();
    },
    computed: {
        ...mapState("dstoreInventories", [
            "loading",
            "param",
            "products",
            "categories"
        ])
    },
    filters: {
        formatDate: function(value) {
            if (value) {
                return moment(String(value)).format("MMM. D, YYYY");
            }
        },
        regularPrice: function(value) {
            return Number.parseFloat(value).toFixed(2);
        },
        salePrice: function(price, discount, discountType) {
            if (discountType === "PHP") {
                let formatDiscount = price - discount;
                return formatDiscount.toFixed(2);
            } else {
                let formatDiscount = price - price * (discount / 100);
                return formatDiscount.toFixed(2);
            }
        }
    },
    methods: {
        getProducts: async function() {
            await this.$store.dispatch(
                "dstoreInventories/getProducts",
                this.param
            );
        },

        getCategoryName: function(id) {
            return this.categories[id];
        },

        editProduct: function(param) {
            this.$store.commit("dstoreInventories/setModal", {
                type: "edit_product",
                status: true
            });
            this.$store
                .dispatch("dstoreInventories/getProduct", {
                    uuid: param.uuid
                })
                .then(() => {
                    this.$store.dispatch(
                        "dstoreInventories/getAvailableProductKeyStocks",
                        {
                            uuid: param.uuid
                        }
                    );
                });
        },

        deleteProduct: async function(param) {
            if (param.productActivationKeysCount == 0) {
                this.$store.commit("dstoreInventories/setModal", {
                    type: "delete_product",
                    uuid: param.uuid,
                    name: param.name,
                    status: true
                });
            } else {
                notification.errorWithoutIcon("Cannot remove because there is an activation key tagged to the product.");
            }
        },

        updateVisibility: function(param) {
            let data = {
                uuid: param.uuid,
                param: {
                    visibility: param.visibility
                }
            };
            this.$store.dispatch(
                "dstoreInventories/updateProductVisibility",
                data
            );
        },
        transformVariationName: function(decodedVariationCode) {
            var variationCode = "";
            if (decodedVariationCode.length >= 1) {
                for (
                    let index = 0;
                    index < decodedVariationCode.length;
                    index++
                ) {
                    variationCode += decodedVariationCode[index].value + " - ";
                }
                return variationCode.substring(0, variationCode.length - 3);
            } else {
                return "N/A";
            }
        }
    },
    watch: {
        param: function(param) {
            this.$store.dispatch("dstoreInventories/getProducts", param);
        }
    }
};
</script>
